<template>
  <section class="relative w-full h-[400px] sm:h-[650px] overflow-hidden bg-white z-0" aria-label="Prezentacja usług budowlanych w Poznaniu, Wrocławiu i Trójmieście">
    <div
        class="flex transition-transform duration-1000 h-full"
        :style="`transform: translateX(-${currentIndex * 100}%)`"
    >
      <div
          v-for="(slide, index) in slides"
          :key="index"
          class="w-full h-full flex-shrink-0 relative"
      >
        <img
            :src="slide.image"
            :alt="slide.alt"
            class="w-full h-full object-cover brightness-75"
        />
        <div class="absolute inset-0 bg-black bg-opacity-40"></div>
      </div>
    </div>

    <!-- Stały tekst centralny -->
    <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-0 text-white z-10">
      <h1 class="text-3xl sm:text-5xl font-bold">
        Remonty i wykończenia wnętrz w Poznaniu, Wrocławiu i Trójmieście
      </h1>
      <p class="text-lg sm:text-2xl mt-2 max-w-3xl">
        Kompleksowe usługi budowlane i wnętrzarskie – solidność, precyzja i nowoczesne podejście.
      </p>
    </div>

    <!-- Nawigacja (kropki) -->
    <div class="absolute left-1/2 bottom-4 transform -translate-x-1/2 flex space-x-2 z-20">
      <span
          v-for="(dot, idx) in slides.length"
          :key="idx"
          class="dot"
          :class="{ 'active-dot': idx === currentIndex }"
      ></span>
    </div>
  </section>
</template>

<script>
export default {
  name: "CarouselHero",
  data() {
    return {
      currentIndex: 0,
      slides: [
        {
          image: require('@/assets/CaroseulImages/image1.jpeg'),
          alt: "Remonty i wykończenia mieszkań i domów – Poznań, Wrocław, Trójmiasto",
        },
        {
          image: require('@/assets/CaroseulImages/image2.jpeg'),
          alt: "Nowoczesne technologie budowlane – usługi w Poznaniu, Wrocławiu i Trójmieście",
        },
        {
          image: require('@/assets/CaroseulImages/image3.jpeg'),
          alt: "Trwałość i estetyka wykonania – usługi ProjectSpot, Poznań i okolice",
        }
      ]
    };
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
  },
  mounted() {
    this.interval = setInterval(this.nextSlide, 5000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.dot {
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 50%;
  opacity: 0.6;
  transition: all 0.3s ease-in-out;
}

.active-dot {
  width: 36px;
  height: 12px;
  background-color: white;
  opacity: 1;
  border-radius: 25px;
  transition: width 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
</style>
